<template>
  <a-modal
    title="指定批属性"
    :visible="visible"
    :width="1040"
    class="bath-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model :form="formData" v-bind="layout" layout="inline">
      <a-row>
        <a-col :span="8">
          <a-form-model-item label="指定批属性">
            <a-select
              v-model="formData.productQuality"
              :get-popup-container="(triggerNode) => (triggerNode.parentElement)"
              allow-clear
              placeholder="请选择指定批属性"
              @change="changeQuality"
            >
              <a-select-option
                v-for="item in BATCHPROPERTIES"
                :key="item.value"
                :value="item.value"
              >{{item.label}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col v-if="formData.productQuality" :span="8">
          <a-form-model-item :label="currentOption.label">
            <component
              :is="currentOption.type"
              v-model="formData[currentOption.value]"
              :get-calendar-container="(triggerNode) => (triggerNode.parentElement)"
              :placeholder="currentOption.placeholder"
              value-format="YYYY-MM-DD"
              :max-length="32"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { BATCHPROPERTIES } from '../goodsTable';

export default {
  name: 'Batch',
  data() {
    return {
      visible: false,
      chooseIndex: null,
      formData: {},
      chooseRow: {},
      layout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      },
      currentOption: {},
      BATCHPROPERTIES,
    }
  },
  methods: {
    show(index, row) {
      this.visible = true;
      this.chooseRow = {...row};
      this.formData = {}
      row.batchAttrs?.forEach(item => {
        this.$set(this.formData, 'productQuality', item.attrCode)
        this.$set(this.formData, item.attrCode, item.attrValue)
      })
      const {productQuality} = this.formData
      if (productQuality) {
        const current = BATCHPROPERTIES.find(item => item.value === productQuality);
        this.currentOption = current;
      }
      this.chooseIndex = index
    },
    changeQuality(value) {
      let current = {};
      if(value) {
        current = BATCHPROPERTIES.find(item => item.value === value);
      }
      BATCHPROPERTIES.forEach(item => {
        this.$set(this.formData, item.value, null);
      })
      this.currentOption = current;
    },
    handleOk() {
      const { productQuality } = this.formData
      if(productQuality && !this.formData[productQuality]) {
        this.$message.error(`请输入${this.currentOption.label}`)
        return
      }
      const batchAttrs = [];
      BATCHPROPERTIES.find(item => {
        if (item.value === productQuality) {
          batchAttrs.push({
            attrCode: item.value,
            attrName: item.label,
            attrValue: this.formData[productQuality]
          })
        }
      })
      this.$emit('changeBatch', this.chooseIndex, {
        ...this.chooseRow,
        batchAttrs,
      });
      this.handleCancel()
    },
    handleCancel() {
      this.visible = false;
    },
  }
}
</script>

<style lang="less" scoped>
  .bath-modal {
    .ant-form-item {
      width: 100%;
      .ant-calendar-picker {
        width: 100%;
      }
    }
  }
  </style>